"use client"

import {
  FaTimes,
  FaChartLine,
  FaMousePointer,
  FaQrcode,
  FaCheckCircle,
  FaTimesCircle,
  FaLock,
  FaArrowRight,
} from "react-icons/fa"
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts"
import { Link } from "react-router-dom"

export default function AnalyticsModal({ show, analyticsData, onClose }) {
  if (!show || !analyticsData) return null

  const linkInfo = analyticsData.linkInfo || {}
  const plan = analyticsData.plan || "free"
  const shortCode = linkInfo.shortCode || "—"

  const isFree = plan === "free"
  // const isPremium = plan === "premium"

  const chartData = !isFree ? analyticsData.daily || [] : []

  const isActive = Boolean(linkInfo.isActive) && (!linkInfo.expiresAt || new Date(linkInfo.expiresAt) > new Date()) 
  

  return (
    <>
      <style>{`
        .analytics-modal-backdrop {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(15, 23, 42, 0.6);
          backdrop-filter: blur(4px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1080;
        }
        .analytics-modal-dialog {
          max-width: 640px;
          width: 90%;
          animation: slideUp 0.2s ease-out;
        }
        .analytics-modal-content {
          background: white;
          border-radius: 12px;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
          overflow: hidden;
        }
        .analytics-modal-header {
          background: #1e293b;
          padding: 20px 24px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .analytics-modal-body {
          padding: 24px;
        }
        .stat-card {
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 10px;
          padding: 20px;
          text-align: center;
          transition: all 0.2s ease;
        }
        .stat-card:hover {
          border-color: #3b82f6;
        }
        .stat-icon {
          width: 44px;
          height: 44px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 12px;
        }
        .chart-section {
          background: #f8fafc;
          border-radius: 10px;
          padding: 20px;
          margin-top: 20px;
        }
        .upgrade-banner {
          background: #fffbeb;
          border: 1px solid #fde68a;
          border-radius: 10px;
          padding: 20px;
          margin-top: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .close-btn {
          background: rgba(255, 255, 255, 0.1);
          border: none;
          color: white;
          width: 32px;
          height: 32px;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: background 0.2s ease;
        }
        .close-btn:hover {
          background: rgba(255, 255, 255, 0.2);
        }
        .btn-view-full {
          background: #3b82f6;
          color: white;
          border: none;
          padding: 8px 16px;
          border-radius: 6px;
          font-weight: 500;
          font-size: 14px;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: background 0.2s ease;
        }
        .btn-view-full:hover {
          background: #2563eb;
          color: white;
        }
        .btn-upgrade {
          background: #3b82f6;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 6px;
          font-weight: 600;
          text-decoration: none;
          transition: background 0.2s ease;
        }
        .btn-upgrade:hover {
          background: #2563eb;
          color: white;
        }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      <div className="analytics-modal-backdrop" onClick={onClose}>
        <div className="analytics-modal-dialog" onClick={(e) => e.stopPropagation()}>
          <div className="analytics-modal-content">
            <div className="analytics-modal-header">
              <div className="d-flex align-items-center gap-3">
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "8px",
                    background: "rgba(255, 255, 255, 0.1)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <FaChartLine size={18} color="white" />
                </div>
                <div>
                  <h5 style={{ margin: 0, color: "white", fontSize: "16px", fontWeight: "600" }}>Link Analytics</h5>
                  <p style={{ margin: 0, color: "rgba(255, 255, 255, 0.7)", fontSize: "13px" }}>{shortCode}</p>
                </div>
              </div>
              <button className="close-btn" onClick={onClose}>
                <FaTimes size={14} />
              </button>
            </div>

            <div className="analytics-modal-body">
                <div className="text-end mb-3">
                  <Link to={`/analytics/${shortCode}`} onClick={onClose} className="btn-view-full">
                    View Full Analytics
                    <FaArrowRight size={12} />
                  </Link>
                </div>

              <div className="row g-3">
                <div className="col-md-4">
                  <div className="stat-card">
                    <div className="stat-icon" style={{ background: "#eff6ff", color: "#3b82f6" }}>
                      <FaMousePointer size={18} />
                    </div>
                    <p style={{ color: "#64748b", fontSize: "13px", fontWeight: "500", marginBottom: "4px" }}>
                      Total Clicks
                    </p>
                    <h3 style={{ color: "#1e293b", fontWeight: "700", margin: 0 }}>{analyticsData.totalClicks || 0}</h3>
                  </div>
                </div>

                {!isFree && (
                  <div className="col-md-4">
                    <div className="stat-card">
                      <div className="stat-icon" style={{ background: "#dcfce7", color: "#22c55e" }}>
                        <FaQrcode size={18} />
                      </div>
                      <p style={{ color: "#64748b", fontSize: "13px", fontWeight: "500", marginBottom: "4px" }}>
                        QR Scans
                      </p>
                      <h3 style={{ color: "#1e293b", fontWeight: "700", margin: 0 }}>
                        {analyticsData.totalQrScans || 0}
                      </h3>
                    </div>
                  </div>
                )}

                <div className={isFree ? "col-md-4" : "col-md-4"}>
                  <div className="stat-card">
                    <div
                      className="stat-icon"
                      style={{
                        background: isActive ? "#dcfce7" : "#fef2f2",
                        color: isActive ? "#22c55e" : "#ef4444",
                      }}
                    >
                      {isActive ? <FaCheckCircle size={18} /> : <FaTimesCircle size={18} />}
                    </div>
                    <p style={{ color: "#64748b", fontSize: "13px", fontWeight: "500", marginBottom: "4px" }}>Status</p>
                    <h3
                      style={{
                        color: isActive ? "#22c55e" : "#ef4444",
                        fontWeight: "700",
                        fontSize: "16px",
                        margin: 0,
                      }}
                    >
                      {isActive ? "Active" : "Disabled"}
                    </h3>
                  </div>
                </div>
              </div>

              {!isFree && chartData.length > 0 && (
                <div className="chart-section">
                  <h6 style={{ color: "#1e293b", fontWeight: "600", marginBottom: "16px" }}>Clicks Over Time</h6>
                  <div style={{ width: "100%", height: 240 }}>
                    <ResponsiveContainer>
                      <AreaChart data={chartData}>
                        <defs>
                          <linearGradient id="modalClicksGradient" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.2} />
                            <stop offset="95%" stopColor="#3b82f6" stopOpacity={0} />
                          </linearGradient>
                        </defs>
                        <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                        <XAxis dataKey="date" stroke="#94a3b8" style={{ fontSize: "11px" }} />
                        <YAxis stroke="#94a3b8" style={{ fontSize: "11px" }} />
                        <Tooltip
                          contentStyle={{
                            borderRadius: "6px",
                            border: "1px solid #e2e8f0",
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                            fontSize: "13px",
                          }}
                        />
                        <Area
                          type="monotone"
                          dataKey="clicks"
                          stroke="#3b82f6"
                          strokeWidth={2}
                          fill="url(#modalClicksGradient)"
                        />
                      </AreaChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              )}

              {isFree && (
                <div className="upgrade-banner">
                  <div className="d-flex align-items-center gap-3">
                    <div
                      style={{
                        width: "44px",
                        height: "44px",
                        borderRadius: "10px",
                        background: "#fef3c7",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#f59e0b",
                      }}
                    >
                      <FaLock size={18} />
                    </div>
                    <div>
                      <h6 style={{ color: "#92400e", fontWeight: "600", marginBottom: "2px" }}>
                        Unlock Detailed Analytics
                      </h6>
                      <p style={{ color: "#a16207", fontSize: "13px", margin: 0 }}>
                        Upgrade to view charts, trends, and detailed insights
                      </p>
                    </div>
                  </div>
                  <Link to="/upgrade" className="btn-upgrade">
                    Upgrade Now
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
